export const KnownFees = ['OUR', 'SHARE', 'BEN', 'SEPA', 'DSP', 'INTERNAL']
